/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import { withMemo } from 'fierry/react.old';

import Center from 'astro/react/map/zone/center';
import Border from 'astro/react/map/zone/border';
import Background from 'astro/react/map/zone/background';

import AttackIndicator from 'astro/react/map/zone/attack.indicator';
//import TransferIndicator from 'astro/react/map/zone/transfer.indicator';


const Component = (props) =>
(
  <Center {...props} >

    <Background {...props} />
    <Border {...props} />

  </Center>
)

export default withMemo(props =>
{
  const { zone } = props;

  return <Component {...props} location = {zone.getLocation()} />;
});
